export function isSelectableRole(role?: string): boolean {
  return (
    role === 'gridcell' ||
    role === 'option' ||
    role === 'row' ||
    role === 'tab' ||
    role === 'columnheader' ||
    role === 'rowheader' ||
    role === 'treeitem'
  );
}

export function isCheckableRole(role?: string): boolean {
  return role === 'checkbox' || role === 'menuitemcheckbox' || role === 'radio' || role === 'menuitemradio';
}
